import Image from 'next/image';
import React from 'react';

const AutomateComplexSolutions = () => {
    return (
        <div
            className="section-py dark:text-light border-b"
            style={{
                borderImageSource: 'linear-gradient(270deg, rgba(60, 69, 97, 0) 0%, #3C4561 50%, rgba(60, 69, 97, 0) 100%)',
                borderImageSlice: 1,
            }}
        >
            <div className="container lg:container mx-auto">
                <div className="row grid lg:grid-cols-12">
                    <div className="lg:col-span-6">
                        <h2 className="mb-[10px] dark:text-white"
                        data-aos="fade-up"
                            data-aos-duration="700"
                            data-aos-delay="200">
                            Automate Complex Workflows with Safe, Autonomous AI Agents
                        </h2>
                        <p className="dark:text-[#D7DEE5]"
                        data-aos="fade-up"
                            data-aos-duration="700"
                            data-aos-delay="200">
                            Transform your enterprise with safe, productive autonomous agents designed for real-world workflows. MCP-powered agents automate workflows end-to-end with built-in security, permissions, and detailed audit trails for every action. These orchestrated agents seamlessly perform tasks across complex systems, guided by Model Context Protocol (MCP) integrations and controlled through secure, auditable environments.
                        </p>
                    </div>
                    <div className="lg:col-span-6">
                        <div className="grid grid-cols-2 sm:grid-cols-1 md:grid-cols-2 gap-7 mb-7">
                            <div className="flex flex-col gap-[9px] card p-5 bg-white rounded-10 border dark:border-[#ffffff33] dark:border-solid dark:bg-[#3C45611A]"
                            data-aos="fade-up"
                            data-aos-duration="700"
                            data-aos-delay="200">
                                <div className="voice-generator-box">
                                    <Image
                                        src="/img/ai-agent/svg/ic-safe-productive.svg"
                                        width={36}
                                        height={36}
                                        alt="safe-productive"
                                    />
                                </div>

                                <p className="fs-md mb-0 dark:text-[#D7DEE5]">
                                    Safe, productive, autonomous agents for real-world workflows
                                </p>
                            </div>
                            <div className="flex flex-col gap-[9px] card p-5 bg-white rounded-10 border dark:border-[#ffffff33] dark:border-solid dark:bg-[#3C45611A]"
                            data-aos="fade-up"
                            data-aos-duration="700"
                            data-aos-delay="200">
                                <div className="voice-generator-box">
                                    <Image
                                        src="/img/ai-agent/svg/ic-orchestrated-agent.svg"
                                        width={36}
                                        height={36}
                                        alt="Orchestrated agents"
                                    />
                                </div>

                                <p className="fs-md mb-0 dark:text-[#D7DEE5]">
                                    Orchestrated agents performing complex tasks across connected systems
                                </p>
                            </div>
                        </div>
                        <div className="grid grid-cols-2 sm:grid-cols-1 md:grid-cols-2 gap-7">
                            <div className="flex flex-col gap-[9px] card p-5 bg-white rounded-10 border dark:border-[#ffffff33] dark:border-solid dark:bg-[#3C45611A]"
                            data-aos="fade-up"
                            data-aos-duration="700"
                            data-aos-delay="200">
                                <div className="voice-generator-box">
                                    <Image
                                        src="/img/ai-agent/svg/ic-mcp-powered.svg"
                                        width={36}
                                        height={36}
                                        alt="MCP-powered controls"
                                    />
                                </div>
                                <p className="fs-md mb-0 dark:text-[#D7DEE5]">
                                    MCP-powered controls ensuring traceability, governance, and sandbox safety
                                </p>
                            </div>
                            <div className="flex flex-col gap-[9px] card p-5 bg-white rounded-10 border dark:border-[#ffffff33] dark:border-solid dark:bg-[#3C45611A]"
                            data-aos="fade-up"
                            data-aos-duration="700"
                            data-aos-delay="200">
                                <div className="voice-generator-box">
                                    <Image
                                        src="/img/ai-agent/svg/ic-ai-automation.svg"
                                        width={36}
                                        height={36}
                                        alt="AI automation"
                                    />
                                </div>
                                <p className="fs-md mb-0 dark:text-[#D7DEE5]">
                                    AI automation built for enterprise-grade transparency and measurable outcomes
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AutomateComplexSolutions;
